<template>
  <div class="settings_right">
    <div class="content-header">
      <div class="content-header-left">
       <!--- <div class="search">
          <vs-input
            icon-pack="feather"
            icon="icon-search"
            v-model="searchtxt"
            placeholder="Search By Name"
            class="is-label-placeholder"
          />
        </div>-->
      </div>
      <div class="content-header-right">
        <vs-inv-dropdown >
       <!-- <vs-dropdown vs-custom-content vs-trigger-click>
          <vs-button
            color="primary"
            class="filter-btn"
            type="border"
            icon-pack="feather"
            icon="icon-chevron-down"
            icon-after
          >
            <img src="@/assets/images/main/icon-filter.svg" /> Filters
          </vs-button> -->
          <!-- <vs-dropdown-menu ref="filter_menu" class="filters-content"> -->
            <div class="filters-content">
            <div class="filters-form-fileds noscroll">
              <div class="form-container">
                <div class="vx-row">
                                   

                  <div class="vx-col md:w-1/3 w-full con-select" v-if="false">
                    <label class="typo__label">Select Status</label>
                    <multiselect
                      v-model="selected_statusids"
                      :options="[{'name':'Deleted' ,'id':false} ,{'name':'Active' ,'id':true}]"
                      :multiple="true"
                      :hideSelected="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Status"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                    >
                      <template
                        slot="selection"
                        slot-scope="{ values, isOpen }"
                      >
                        <span
                          class="multiselect__selectcustom"
                          v-if="values.length && !isOpen"
                          >{{ values.length }} Status Selected</span
                        >
                        <span
                          class="multiselect__selectcustom"
                          v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>

                  <div class="vx-col md:w-1/3 w-full con-select">
                  <label class="form_label">Case Subtypes</label>
                  <div class="con-select w-full mt-0 case-sub-types">

                  <multiselect
                  name="desiredsoccode"
                  v-model="subTypeDateils"
                  :options="petitionConfigList"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select Case Subtypes"

                  :preselect-first="false"
                  data-vv-as=" Case Type"

                  group-values="subTypes"
                  group-label="caseType" 
                  :group-select="true" 

                  track-by="name" 
                  label="name"



                  > 
                  <template slot="selection" slot-scope="{ values, isOpen }">
                  <span
                  class="multiselect__selectcustom"
                  v-if="values.length && !isOpen"
                  >{{ values.length }} Case Type(s) Selected</span
                  >
                  <span
                  class="multiselect__selectcustom"
                  v-if="values.length && isOpen"
                  ></span>
                  </template>
                  </multiselect>



                 
                  </div>
                  </div>
                  <div class="vx-col md:w-1/3 w-full con-select" v-if="[1].indexOf(getUserRoleId)>-1">
                  <label class="form_label">Customer</label>
                  <div class="con-select w-full mt-0">

                  <multiselect
                  name="desiredsoccode"
                  v-model="tenantIdsDetails"
                  :options="tenantList"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select Customer"

                  :preselect-first="false"
                   track-by="name" 
                  label="name"



                  > 
                  <template slot="selection" slot-scope="{ values, isOpen }">
                  <span
                  class="multiselect__selectcustom"
                  v-if="values.length && !isOpen"
                  >{{ values.length }} Case Type(s) Selected</span
                  >
                  <span
                  class="multiselect__selectcustom"
                  v-if="values.length && isOpen"
                  ></span>
                  </template>
                  </multiselect>



                  <span   class="text-danger text-sm" v-show="errors.has('caseCodeForm.desiredsoccode')"  >{{ errors.first("caseCodeForm.desiredsoccode") }}</span>
                  </div>
                  </div>

                  <div class="vx-col md:w-1/3 w-full con-select">
                    
                    <label class="form_label">Created Date</label>
                    <date-range-picker
                      :maxDate="new Date()"
                      :autoApply="autoApply"
                      :ranges="false"
                      v-model="selected_createdDateRange"
                      :opens="'left'"
                    ></date-range-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="filters-status">
              <div class="left-buttons"></div>
              <div class="right-buttons">
                <vs-button
                  color="success"
                  class="save"
                  type="filled"
                  v-on:click="set_filter()"
                  >Apply</vs-button
                >
                <vs-button
                  color="dark"
                  class="cancel"
                  type="filled"
                  v-on:click="clear_filter($event)"
                  >Clear</vs-button
                >
              </div>
            </div>
          </div>
          <!-- </vs-dropdown-menu>
        </vs-dropdown> -->
      </vs-inv-dropdown>
     
        <vs-button
          type="border"
         
          class="light-blue-btn"
          @click="addNew()"
          >Add Configuration<span>
            <img
              class="add-user-icon ml-2"
              src="@/assets/images/main/add-user.svg"
            />
          </span>
        </vs-button>
      </div>
    </div>
    <!-- {{$store.state.user.loginRoleId}} -->
    <!--- You haven\'t  created any User Roles yet. Create a User Roles to start using the ImmiBox ---->
    <NoDataFound
      ref="NoDataFoundRef"
      v-if="list.length == 0"
      :content="callFromSerch ? '' : ''"
      :heading="callFromSerch ? 'No Results Found' : 'No Case Code Configuration Found'"
      type="User Roles"
    />
   <!-- {{list}} -->
    <div class="accordian-table casecodeconfig_tabel" v-if="list.length > 0">
      <vs-table :data="list" :no-data-text="'No data found..!'">
        <template slot="thead" v-if="list.length > 0">
        <!-- "path": "createdOn", // name, createdByName, typeName-->
          <vs-th>
            SI. No. Starts From 
          </vs-th>
           <vs-th v-if="[1].indexOf(getUserRoleId)>-1">
           Customer
          </vs-th>
           <vs-th>
            Case Subtypes
          </vs-th>
          <vs-th><a
              @click="sortMe('createdOn')"
              v-bind:class="{
                sort_ascending: sortKeys['createdOn'] == 1,
                sort_descending: sortKeys['createdOn'] != 1,
              }"
            >Created On</a></vs-th>
             <vs-th><a
              @click="sortMe('updatedOn')"
              v-bind:class="{
                sort_ascending: sortKeys['updatedOn'] == 1,
                sort_descending: sortKeys['updatedOn'] != 1,
              }"
            >Updated On</a>
            </vs-th>
           
          <vs-th class="actions">Actions</vs-th>
        </template>

        <template>
          <template v-for="(tr, indextr) in list">
            <vs-tr
              :data="tr"
              :key="indextr"
            >
             <vs-td :data="tr"> {{ checkProperty( tr ,'sNoStartsFrom') }}</vs-td>
             <vs-td :data="tr" v-if="[1].indexOf(getUserRoleId)>-1"> {{ checkProperty( tr ,'tenantDetails' ,'name') }}</vs-td>
              <!-- <vs-td :data="tr"> {{ checkProperty( tr,'subTypeDetails' ,'name') }}</vs-td> -->
            <vs-td :data="tr" >
               <!-- <div class="tasks_footer"> 
                <div class="tasklist_persons">
                 <div class="peoples_list IB_tooltip premium_tooltip" v-if="checkProperty(tr,'subTypeDetails' ,'length')>0">
              <dropdown-menu
                v-model="show1"
                :left="true"
                :hover="true"
                :interactive="false"
                :closeOnClickOutside="true" 
                ref='subTypeDetails'
                id='subTypeDetails'
              >
                  <figure class="people_dp ">                      
                    <img  src="@/assets/images/asigne.svg">
                  </figure>
                  <div slot="dropdown">
                      <div class="peoples-detailes-wrap">
                        <ul class="peoples-detailes-dropdown">
                            <li class="peoples-detailes_cnt" v-for="(user ,indx ) in tr['subTypeDetails']" :key="indx">
                              <div class="people-content">
                                  <h5>{{checkProperty(user ,'name')}}</h5>
                                </div>
                            </li>
                        </ul>
                      </div> 
                  </div>
              </dropdown-menu>
              <div class="tooltip_cnt"><p>Case Sub Type(s)</p></div>
                </div>
                </div>
               </div>  -->
              <div class="subtypes__list">
                <ul>
                <template v-for="(user ,indx ) in tr['subTypeDetails']">
                  <li :key="indx" v-if="indx<=1" ><span>{{checkProperty(user ,'name')}}</span></li>
                  
                </template>

                  <!-- <li v-if="checkProperty(tr ,'subTypeDetails' ,'length')>2" >
                    <dropdown-menu
                      v-model="tr.subtype"
                      :left="true"
                      :hover="true"
                      :interactive="false"
                      :closeOnClickOutside="true" 
                      :ref="'assignedToDetails'+indextr"
                      :id="'assignedToDetails'+indextr"
                    >
                      <em class="more_count ">                      
                        +{{(checkProperty(tr ,'subTypeDetails' ,'length'))-2}}
                       
                      </em>
                      <div slot="dropdown">
                          <ul>
                             <template v-for="(user ,indx ) in tr['subTypeDetails']">
                                   <li :key="indx" v-if="indx>1" ><span>{{checkProperty(user ,'name')}}</span></li>
                  
                              </template>
                            
                          </ul>
                      </div>
                    </dropdown-menu>
                  </li> -->

                  <li v-if="checkProperty(tr ,'subTypeDetails' ,'length')>2">
                      <div class="menu_dropdown flexible_actions right">
                      <em class="more_count ">                      
                        +{{(checkProperty(tr ,'subTypeDetails' ,'length'))-2}}                       
                      </em>
                      <div class="menu_list_wrap">
                        <ul>
                        <VuePerfectScrollbar
                              ref="mainSidebarPs"
                              class="scroll-area--main-sidebar"
                              :settings="settings"
                              @ps-scroll-y="psSectionScroll"
                            >
                          <template v-for="(user ,indx ) in tr['subTypeDetails']">
                            <li :key="indx" v-if="indx>1" >{{checkProperty(user ,'name')}}</li>                  
                          </template> 
                        </VuePerfectScrollbar>               
                        </ul>
                        
                      </div>
                  </div>
                  </li>
                </ul>
              </div>
            </vs-td>
             <vs-td >{{tr['createdOn'] | formatDate}} </vs-td>
             <vs-td  class="td_label"> 
             
              <template v-if=" checkProperty( tr,'updatedOn')" >  {{ checkProperty( tr,'updatedOn') | formatDate }}</template>
               <!---  <small> {{ checkProperty(tr ,'createdByRoleName') }} </small>--->
              </vs-td>
              <vs-td >
                <vs-dropdown class="msg_dropdown_icon" :vs-trigger-click="true">
                  <a class="a-icon" href.prevent
                    ><more-vertical-icon
                      size="1.5x"
                      class="custom-class"
                    ></more-vertical-icon
                  ></a>
                  <vs-dropdown-menu class="loginx msg_dropdown">
                    <vs-dropdown-item>
                      <a
                        style="cursor: pionter; padding: 3px 10px"
                        href.prevent
                        @click="editMe(tr)"
                        >Edit</a
                      >
                    </vs-dropdown-item>
                    <vs-dropdown-item  >
                     <a @click="deleteMe(tr)"  href.prevent><p style="cursor:pionter"  >Delete</p></a>
                   </vs-dropdown-item>
                    
                      <vs-dropdown-item>
                      <a
                        style="cursor: pionter; padding: 3px 10px"
                        href.prevent
                        @click="showViewModal(tr)"
                        >View</a
                      >
                    </vs-dropdown-item>
                    

                 
                  </vs-dropdown-menu>
                </vs-dropdown>
              </vs-td>
            </vs-tr>
          </template>
        </template>
      </vs-table>
      <div class="table_footer">
        <div class="vx-col  con-select pages_select"  v-if="list.length>0">
          <label class="typo__label">Per Page</label>
          <multiselect @input="changeperPage()" v-model="perpage" :options="perPeges" :multiple="false"
              :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Per Page"
              :preselect-first="true" :allow-empty="false">
            </multiselect>
            <span class="totla_list_count" v-if="totalCount"> Total <em>{{totalCount}}</em></span>
          </div>
          <paginate
        v-if="list.length > 0"
        v-model="page"
        :page-count="totalpages"
        :page-range="3"
        :margin-pages="2"
        :click-handler="pageNate"
        prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
        next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next"
        :prev-text="'<i></i>'"
        :next-text="'<i></i>'"
        :container-class="'pagination vs-pagination--nav'"
        :page-class="'page-item'"
      ></paginate>
      </div>
      
    </div>
 


     
 


        <modal
      name="serviceCenterViewModal"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="500px"
      height="auto"
    >
   
     <div class="v-modal" >
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">Case Code Details</h2>
          <span @click="hideViewModal()">
            <em class="material-icons">close</em>
          </span>
        </div>
       
          <div class="form-container">
            

           <div class="vx-row" >

            <div class="vx-col w-100"  v-if="checkProperty(selectedCaseDetails ,'subTypeDetails','length')" >
                <div class="form_group d-block">
                <div class="form_label">  
                <label >Case Subtype(s) Details</label>
                </div><br>
                  <ul class="uploaded-list note_uploads" >
                    <template  v-for="(item, index) in selectedCaseDetails['subTypeDetails']"  >
                      <vs-chip :key="index">
                        {{ item.name }}
                      </vs-chip>
                    </template>
                  </ul>
                </div> 
             </div> 
              <div class="vx-col w-1/2"  v-if="checkProperty(selectedCaseDetails ,'tenantDetails','name' ) && [1].indexOf(getUserRoleId)>-1 ">
              <div class="form_group d-block">
                <label class="form_label">Customer Name</label>
                <span>{{ checkProperty(selectedCaseDetails ,'tenantDetails','name') }}</span>
              </div> 
            </div>
 
              
              <div class="vx-col w-full"  v-if="checkProperty( selectedCaseDetails ,'config' ,'length')>0" >
                <div class="form_group d-block">
                 <label class="form_label">Case Code Configuration</label>
                 <ul class="config-list">
                 <li v-for="(codeItem , indx) in selectedCaseDetails['config']" :key="indx"> <span>{{ checkProperty(codeItem ,'name') }}</span><em class="config-separater">-</em></li> 
                 </ul>
                 
                </div> 
              </div>
              
              <div class="vx-col w-full"  v-if="caseCode" >
                <div class="form_group d-block">
                 <label class="form_label">Example Case ID</label>
                  <p class="value">{{ caseCode }}</p>
                </div> 
              </div>
               <div class="vx-col w-1/2"  v-if="checkProperty(selectedCaseDetails ,'sNoStartsFrom' )"  >
                <div class="form_group d-block">
                 <label class="form_label">SI. No. Starts From </label>
                  <p class="value">{{ checkProperty(selectedCaseDetails ,'sNoStartsFrom') }}</p>
                </div>
              </div>
              <div class="vx-col w-1/2"  v-if="checkProperty(selectedCaseDetails ,'resetIdBy' )"  >
                <div class="form_group d-block">
                 <label class="form_label">SI. No. Reset On</label>
                  <p class="value">{{ checkProperty(selectedCaseDetails ,'resetIdBy') }}</p>
                </div>
              </div>
               <div class="vx-col w-1/2"  v-if="checkProperty(selectedCaseDetails ,'createdByName' )"  >
                <div class="form_group d-block">
                 <label class="form_label">Created By</label>
                  <p class="value">
                    <span>{{ checkProperty(selectedCaseDetails ,'createdByName') }}</span>
                    <small>({{ checkProperty(selectedCaseDetails ,'createdByRoleName') }})</small>
                  </p>
                </div> 
              </div>

              <div class="vx-col w-1/2"  v-if="checkProperty(selectedCaseDetails ,'createdOn' )"  >
                <div class="form_group d-block">
                 <label class="form_label">Created On</label>
                  <p class="value">{{ checkProperty(selectedCaseDetails ,'createdOn') | formatDateTime}}</p>
                </div> 
              </div>
              
              <div class="vx-col w-1/2"  v-if="checkProperty(selectedCaseDetails ,'updatedOn' )"  >
                <div class="form_group d-block">
                 <label class="form_label">Updated On</label>
                  <p class="value">{{ checkProperty(selectedCaseDetails ,'updatedOn') | formatDateTime}}</p>
                </div> 
              </div> 
              
           
             
            </div>  
          
          
          </div>
           <div class="popup-footer relative">
            <vs-button
              color="dark"
              @click="hideViewModal();  "
              class="cancel"
              type="filled"
              >Cancel</vs-button
            >
        </div> 
        </div>
        </modal> 
    

    <modal
      name="caseCodeConfigurationDeleteModel"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="500px"
      height="auto"
    >
     <div class="v-modal" >
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">Delete Configuration</h2>
          <span @click="$modal.hide('caseCodeConfigurationDeleteModel')">
            <em class="material-icons">close</em>
          </span>
        </div>
       
          <div class="form-container" @click="formerrors.msg =''" >
            <div class="vx-row">
              <div class="vx-col w-100"   >
                <div class="form_group d-block">
                  <span> Do you want to Delete?</span>
                </div> 
              </div> 
            </div>     

          <div class="text-danger text-sm formerrors" v-show="formerrors.msg" >
                  <vs-alert
                    color="warning"
                    class="warning-alert reg-warning-alert no-border-radius  mb-0"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >{{ formerrors.msg }} </vs-alert>
            </div>
          
          </div>
           <div class="popup-footer relative">
            <vs-button
             :disabled="deleting"
              color="dark"
              @click="$modal.hide('caseCodeConfigurationDeleteModel');  "
              class="cancel"
              type="filled"
              >No</vs-button
            >
             <vs-button
              :disabled="deleting"
             
              color="success"
              class="save"
              @click="deleteCodeConfig()"
              type="filled"
              >Yes</vs-button
            >
        </div> 
        </div>
        </modal> 

        <div  class="workflow_view_wrap emailtemplate code-config_wrap" :class="{ listopen: addPopup }">
        <div class="workflow_overlay"   @click="addPopup = false"></div>
        <div class="workflow_view_cnt questionary_cnt" style="width:90%">
          <div class="workflow_view_title view__title"  >
            <div>
              <label>
              <template v-if="edit">Edit Configuration</template>
               <template v-else>Add Configuration</template>
              
              </label>
            </div>
            <span @click="addPopup = false"><x-icon size="1.5x" class="custom-class"></x-icon></span>
          </div> 

          <div class="workflow_view_sec pad0" v-if="addPopup">
             <addCaseCodeConfig  :isEdit="edit"  @reloadList="getList()" @hideAddPopup="hideModel" :editItem="selectedItem" />
          </div>
        </div> 
        </div> 

    
  </div>
</template>

<script>
import vsInvDropdown from "@/views/vs-inv-dropdown.vue";
import DateRangePicker from "vue2-daterange-picker";
import Datepicker from "vuejs-datepicker-inv";
import Paginate from "vuejs-paginate"; 
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import _ from "lodash";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import moment from "moment";
import PhoneMaskInput from "vue-phone-mask-input";
import JQuery from "jquery";
import { TheMask } from "vue-the-mask";
import DropdownMenu from '@innologica/vue-dropdown-menu';
import FileUpload from "vue-upload-component/src";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { MoreVerticalIcon } from "vue-feather-icons";
import NoDataFound from "@/views/common/noData.vue";
import { XIcon } from 'vue-feather-icons'
//import addressFields from "@/views/common/addressForm.vue";
import addressFields from "@/views/forms/fields/address.vue";
import addCaseCodeConfig from "@/views/tenant/addCaseCodeConfig.vue"
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
   provide() {
        return {
            parentValidator: this.$validator,
        };
    },
  computed: {
     acceptedFiles(){
      let returnValue ='*';
     
          returnValue ='application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        

     
      return returnValue;
      //image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document
    }
    
  },
  components: {
    vsInvDropdown,
   // addressFields,
   addCaseCodeConfig,
   DropdownMenu,
   XIcon,
    NoDataFound,
    DateRangePicker,
    VuePhoneNumberInput,
    Datepicker,
    Paginate,
    FileUpload,
    FormWizard,
    TabContent,
    PhoneMaskInput,
    TheMask,
    MoreVerticalIcon,
    VuePerfectScrollbar
    
  },

  data: () => ({
    caseCode:'',
    selectedPetitioner :{ 'customId':'srinfotech-COMPANY-16',"name": "srinfotech"},
      caseType:{ "caseType": "H-1B", "subTypes": [ { "id": 1, "name": "Amendment", "label": "Amendment" }]},
      caseSubType :{ "id": 1, "name": "Amendment", "label": "Amendment" },

    deleting:false,
    show1:false,
    subtype:false,
   subTypeDateils:[],
   tenantIdsDetails:[],
   tenantList:[],
   filteredServiceCenters:[],
   selected_statusids:[],
    countries:[],
    value:[],
    uploading:false,
      allTags:[],
     
     
    
    callFromSerch: false,
    selected_createdDateRange: ["", ""],
    autoApply: "",
    value: [],
    selectedItem: null,
   formerrors: {
      msg: "",
    },
    date: null,
    approveConformpopUp: false,

    newform: {name: "", 
    description: "" ,
    typeId:'' ,
    typeDetails:null,
    "address": ""
    /*{
        line1: "",
        line2: "",
        zipcode: "",
        countryId:null,
        countryDetails: null,
        stateId:null,
         locationId:null,
        stateDetails: null,
        locationDetails: null,
        aptType:'',
      }
      */
    },
    list: [],
    addPopup: false,
    searchtxt: "",
    query: [],
    selectedCaseDetails:'',
    date: "",
    date_range: [],
    page: 1,
      perPeges: [10,25,50,75,100],
      perpage: 25,
      totalCount:0,
      totalpages: 0,
     edit: false,
    sortKeys: {},
    sortKey: {},
    petitionConfigList:[],
    
    
  }),
  watch: {
    searchtxt: function (value) {
      this.getList(true);
    },
  },
  methods: {
    changeperPage(){
        this.page = 1;
        this.getList(true);
      },
     getPetitionersList(){
            
            let postData = {
                "page":1,
                "perpage":25,
                "matcher":
                    {
                        "searchString":"s",
                        "statusIds":[],
                        "countryIds":[],
                        "stateIds":[],
                        "locationIds":[],
                        "createdDateRange":[],
                        "statusList":[]
                    },
                "sorting":{
                    "path":"createdOn",
                    "order":-1
                    }
            };
      this.$store
        .dispatch("commonAction", { data: postData, path: "/company/list" })
        .then((response) => {

           let petitionerList= response.list;
           if(this.checkProperty(petitionerList ,'length')>0){
              this.selectedPetitioner = petitionerList[_.random( petitionerList.length-1)];

           }
          
        })
        },

     prePareCaseCode(configItem){
        this.caseCode ='';
        let tempCaseCodeList =[];

          
         

       
        _.forEach(configItem.config ,(item ,index)=>{

        
              if(_.get(item ,"id")){
             //   alert( _.get(item ,"id"))
              }
             //CUSTOMER_CODE 
             if(_.get(item ,"id")=="CUSTOMER_CODE"){

               if(this.checkProperty(this.selectedPetitioner ,"idPrefix")){

                     let customId =   _.cloneDeep(this.checkProperty(this.selectedPetitioner ,"idPrefix"))
                    customId =customId.toUpperCase();
                    tempCaseCodeList.push(customId);
                    
                }else if(this.checkProperty(this.selectedPetitioner ,"customId")){
                        let customId =   _.cloneDeep(this.checkProperty(this.selectedPetitioner ,"customId"))
                        customId =customId.toUpperCase();
                        tempCaseCodeList.push(customId);

                    } 
                
            }else if(_.get(item ,"id")=="CASE_TYPE_CODE"){

              if(this.checkProperty(configItem ,'seletedTypeSubTypeDetails' ,"caseMainType") && (_.get(configItem ,"seletedTypeSubTypeDetails.caseMainType.code") || _.get(configItem ,"seletedTypeSubTypeDetails.caseMainType.name") )){
                     let caseCode ="H-1B";
                    if(_.get(configItem ,"seletedTypeSubTypeDetails.caseMainType.code")){
                       caseCode =  configItem["seletedTypeSubTypeDetails"]["caseMainType"]["code"];
                        

                    }else{
                         caseCode = _.cloneDeep( configItem["seletedTypeSubTypeDetails"]["caseMainType"]["name"]);
                       

                    }
                     caseCode = caseCode.toUpperCase();
                     tempCaseCodeList.push(caseCode);


                }else if(this.checkProperty(this.caseType ,"code")){
                  tempCaseCodeList.push(this.caseType['code'].toUpperCase());
              }else{
                  tempCaseCodeList.push(this.caseType['caseType'].toUpperCase());
              }
               
               
                
            }else  if(_.get(item ,"id")=="CASE_SUBTYPE_CODE"){

              if(this.checkProperty(configItem ,'seletedTypeSubTypeDetails' ,"caseSubType") && (_.get(configItem ,"seletedTypeSubTypeDetails.caseSubType.code") || _.get(configItem ,"seletedTypeSubTypeDetails.caseSubType.name") )){
                    let csb ="Amendment";
                    if(_.get(configItem ,"seletedTypeSubTypeDetails.caseSubType.code")){
                       csb = _.cloneDeep( configItem['seletedTypeSubTypeDetails']['caseSubType']['code'])
                       

                    }else{
                          csb = _.cloneDeep(configItem['seletedTypeSubTypeDetails']['caseSubType']['name'])
                        

                    }
                    csb = csb.toUpperCase();
                    tempCaseCodeList.push(csb);


                }else if(this.checkProperty(this.caseSubType ,"code")){
                  tempCaseCodeList.push(this.caseSubType['code'].toUpperCase());
              }else{
                 tempCaseCodeList.push(this.caseSubType['name'].toUpperCase());
              }
              
               //
               
                
                
            }else if(_.get(item ,"id")=="PETITIONER_NAME"){
               
                    let petName = "Christopher";
                 if(this.checkProperty(this.selectedPetitioner ,"name")){
                    petName = this.selectedPetitioner['name']
                 }

                let arr = petName.split(" ");
                for (var i = 0; i < arr.length; i++) {
                    arr[i] = arr[i].toUpperCase() + arr[i].slice(1);

                }
               let str2 = arr.join("_");
               tempCaseCodeList.push(str2); 
           
           
                
            }else if(_.get(item ,"id")=="BENEFICIARY_NAME"){
               
              tempCaseCodeList.push("JON_STEWART");
                
            }else if(_.get(item ,"id")=="SPONSOR_NAME"){
               
                tempCaseCodeList.push("WILLIAM");
                
            }else if(_.get(item ,"id")=="APPLICANT_NAME"){
               
               tempCaseCodeList.push("JAMES_LEW");
                
            }else if(_.get(item ,"id")=="YYYY"){
               
                tempCaseCodeList.push(moment().format('YYYY'));
 
                
            }else if(_.get(item ,"id")=="MMYYYY"){
               
                tempCaseCodeList.push(moment().format('MMYYYY'));

            }else if(_.get(item ,"id")=="MMDDYYYY"){
               
               tempCaseCodeList.push(moment().format('MMDDYYYY'));

           }else if(_.get(item ,"id") =="SI_NO"){
                tempCaseCodeList.push(configItem.sNoStartsFrom);
               
            }
            if(this.checkProperty( tempCaseCodeList ,"length")>0){
                 this.caseCode =tempCaseCodeList.join("-");
            }
           


            

        })

      },
    getTenantList(){
      
        let matcher = {};
        let query = {};
        query['page'] = 1;
        query['perpage'] = 10000;
         query['getMasterData'] = true;
        query['filters'] = matcher;
              

        this.$store
          .dispatch("getList",{data:query ,path:'/tenant/list'} )
          .then(response => {
            this.tenantList = response.list;

          });
    },
       getPetitionConfigList() {
      
      
      let postData = {
          "filters":{
            "tenantIds": [], // Send only for roles 1 and 2
            "statusList": [],
            "activeList": [],
            "typeIds": [],
            "subTypeIds": [],
            "statusList": [],
            "createdDateRange": []
          },
          "page": 1, // Optional when 'getAll' send as 'true'
          "perpage": 100000000,// Optional when 'getAll' send as 'true'
          "getAll": true, // Send as 'true' to get all list
          "getByPetitionType":true
          
	};
      this.$store
        .dispatch("commonAction", { data: postData, path: "/petition-config/list" })
        .then((response) => {
            let petitionConfigList = response.list;
             _.forEach(petitionConfigList , (mainTypeItem) => {
                let groupItem = {
                    caseType:'',
                   "subTypes":[],
                   code:''
                }
                 groupItem['caseType'] =mainTypeItem['name'] ;
                   groupItem['code'] = this.checkProperty(mainTypeItem ,'code');
            
                  if(this.checkProperty(mainTypeItem ,'subTypes' ,'length') >0){
                    groupItem['subTypes'] = mainTypeItem['subTypes'].map((subItem)=>{
                      let sbItem ={"id":subItem['id'],"name":subItem['name'] ,"label":subItem['name'] ,"code":''}
                      sbItem['code'] =this.checkProperty(subItem ,'code');
                        return sbItem
                    })
                    if(this.checkProperty(groupItem ,'subTypes' ,'length')>0){
                        this.petitionConfigList.push(groupItem);
                    }
                  }



             })

             this.caseType = this.petitionConfigList[_.random(this.petitionConfigList.length-1)];
         
          if(this.checkProperty(this.caseType ,'subTypes' ,'length' )>0){
             this.caseSubType = this.caseType['subTypes'][_.random(this.caseType['subTypes'].length-1)];
             
          }else{

              this.caseType = { "caseType": "H-1B", "subTypes": [ { "id": 1, "name": "Amendment", "label": "Amendment" }]};
              this.caseSubType ={ "id": 1, "name": "Amendment", "label": "Amendment" }

          }
           
        });
        },
    editMe(item){
         this.selectedItem =_.cloneDeep(item);
          this.edit= true;
           this.addPopup =true;
    },
     
   
      showViewModal(item){
        this.edit= false;
            this.selectedItem =_.cloneDeep(item);
            if(_.has(this.selectedItem ,"_id")){
              let postData ={"configId":""}
               postData['configId'] = this.selectedItem['_id'];
               this.$store.dispatch("commonAction", {"data":postData ,"path":"/case-id-config/details"})
               .then((response)=>{
                this.selectedCaseDetails=response;
                this.selectedCaseDetails =Object.assign(this.selectedCaseDetails ,{"seletedTypeSubTypeDetails":null})
                
                 //selectedCaseDetails['subTypeIds']
                 //petitionConfigList
              
                if(this.checkProperty(this.selectedCaseDetails ,'subTypeIds' ,'length') >0){

                  _.forEach(this.petitionConfigList ,(mainTypItem)=>{
                            let caseT ={  "caseType": "", "caseTypeId": '', code:'' }
                                caseT['caseType']  =this.checkProperty( mainTypItem, 'caseType');
                                caseT['caseTypeId']  =this.checkProperty( mainTypItem, 'caseType');
                                caseT['code']  =this.checkProperty( mainTypItem, 'code');
                                caseT['name']  =this.checkProperty( mainTypItem, 'caseType');

                            if(this.checkProperty(mainTypItem ,'subTypes' ,'length') >0){
                                 _.forEach(mainTypItem['subTypes'] , (subItem) => {

                                     let subTypeId = this.selectedCaseDetails['subTypeIds'][_.random(this.selectedCaseDetails['subTypeIds'].length-1)];
                                        if(subTypeId == subItem['id'] ){
                                            // "caseType": "H-1B", "caseTypeId": 1,
                                            this.selectedCaseDetails['seletedTypeSubTypeDetails'] ={
                                                'caseMainType':caseT,
                                                "caseSubType":subItem

                                            }

                                        }

                                 })

                               

                            }


                    });
                 }    

                this.prePareCaseCode(this.selectedCaseDetails);
                 this.$modal.show('serviceCenterViewModal');
               }).catch((error)=>{
                  this.showToster({message:error,isError:true });
                 

               })
             
            } 

      },
      hideViewModal(){
          this.$modal.hide('serviceCenterViewModal');
      },
      
     
     
     
      addNew(){
          
          this.addPopup =true;
          this.edit =false;
         
        Object.assign(this.formerrors, { msg: "" });
         
      },
      hideModel(){
          this.addPopup =false;
          this.edit =false;
        
         Object.assign(this.formerrors, { msg: "" });
       
         

      },
    sortMe(sort_key = "") {
      if (sort_key != "") {
        this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        // this.sortKey[sort_key] = this.sortKeys[sort_key]
        this.sortKey = { path: sort_key, order: this.sortKeys[sort_key] };

        localStorage.setItem("userroles_sort_key", sort_key);
        localStorage.setItem("userroles_sort_value", this.sortKey[sort_key]);
        this.getList();
      }
    },
    
    deleteMe(item){
       this.selectedItem = _.cloneDeep(item);
       this.deleting =false;
       this.formerrors.msg =''
       this.$modal.show('caseCodeConfigurationDeleteModel');
    },

    deleteCodeConfig(){

       if(_.has(this.selectedItem ,"_id")){
             
            let postData ={"configId":""}
             postData['configId'] = this.selectedItem['_id'];
             this.deleting =true;
               this.$store
              .dispatch("commonAction", {"data":postData ,"path":"/case-id-config/delete"})
              .then(response => {
               
                //lca_request_msg
                this.$modal.hide('caseCodeConfigurationDeleteModel');
                  this.getList();
                 this.showToster({message:response.message,isError:false });
                
                  this.deleting = false;
                
                                
              })
              .catch((error)=>{
               
                Object.assign(this.formerrors, { msg: error });
                 this.deleting = false;
              })
          }

    },

  


     getDetails(){
        let  postData ={'serviceCenterId':''};
        postData['serviceCenterId'] = this.checkProprty(this.selectedItem , '_id');
        this.$store
        .dispatch("commonAction", {"data":postData ,"path":"/service-centers/details"})
        .then(response => {
        
          this.showToster({message:response.message,isError:false });
                
                        
        })
        .catch((error)=>{
              this.showToster({message:error,isError:false });
        })
     
    
    },

    

    getList(callFromSerch = false) {
      this.callFromSerch = callFromSerch;
      if (this.callFromSerch) {
        this.list = [];
      }
      this.updateLoading(true);
    
      let matcher = {
            "tenantIds": [],
            "groupCodes": [],
            "subTypeIds": [],
            "createdDateRange": []
      };
        //this.selected_statusids = [];
    // this.filteredServiceCenters = [];
      
      
      if (
        this.selected_createdDateRange["startDate"] &&
        this.selected_createdDateRange["startDate"] != "" &&
        this.selected_createdDateRange["endDate"] != "" &&
        this.selected_createdDateRange["endDate"]
      ) {
        matcher["createdDateRange"] = [
          moment(this.selected_createdDateRange["startDate"]).format("YYYY-MM-DD"),
          moment(this.selected_createdDateRange["endDate"]).format("YYYY-MM-DD")
        ];
      }
      matcher['subTypeIds']= this.subTypeDateils.map((item)=> item.id);
      matcher['tenantIds']=this.tenantIdsDetails.map((item)=>item._id);
      let query = {};
      query["page"] = this.page;
      query["perpage"] = this.perpage;
      query["filters"] = matcher;
      query["sorting"] = this.sortKey;
   
     this.$store.dispatch("commonAction", {"data":query ,"path":"/case-id-config/list"})
        .then((response) => {
          this.list = response.list;

          this.updateLoading(false);
          this.totalCount = this.checkProperty(response, 'totalCount');
          this.totalpages = Math.ceil(response.totalCount / this.perpage);
          //alert(this.perpage);
        })
        .catch(() => {
          this.list = [];
          this.updateLoading(false);
        });
    },
 
    set_filter: function () {
      // this.$refs["filter_menu"].dropdownVisible = false;
      document.body.classList.remove('scroll-hidden');
      this.page =1;
      this.getList(true);
    },
    clear_filter: function () {
      this.tenantIdsDetails =[];
      this.filteredServiceCenters =[];
      this.selected_statusids =[];
      this.subTypeDateils=[];
      this.searchtxt = "";
      // this.$refs["filter_menu"].dropdownVisible = false;
      document.body.classList.remove('scroll-hidden');
      
      this.selected_createdDateRange["startDate"] = "";
      this.selected_createdDateRange["endDate"] = "";
      this.getList();
    },
    pageNate(pageNum) {
      this.page = pageNum;
      this.getList();
    },

    
  },
  mounted() {
 
     if([1].indexOf(this.getUserRoleId)>-1){
      this.getTenantList();
     }else{
      this.getPetitionersList();
     }
    this.getPetitionConfigList()
    
    let loginRoleId = this.getUserRoleId;
          this.allowed_roles = [2,3,4, 5, 6, 7, 8, 9, 10, 11,12,13];

    if (loginRoleId == 3) {
      this.allowed_roles = [4, 5, 6, 7, 8, 9, 10, 11, 13];
    }
    if (loginRoleId == 4) {
      this.allowed_roles = [5, 6, 7, 8, 9, 10, 11, 12];
    }
    if (this.$route.name != "basic-settings") {
      this.$store.dispatch("updateSidebarWidth", "extended");
    }
    //
 
  
    // this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", false);
    this.selected_statusids = [];
    this.filteredServiceCenters = [];
   
    
    this.sortKeys = {
      name: 1,
      type: 1,
      createdOn: -1,
      createdByName: 1,
      typeName:1,
      updatedOn:1
    }

      this.sortKey = { path: "createdOn", order: -1 };
//"createdOn", // name, createdByName, typeName
    
    this.getList();
  },
};
</script>
